export default "__VITE_ASSET__D5Ie2Wth__"